const locales = require('../locales/index');
import { getConfigForAppdomain } from './index';

const translate = {
    pluralRuleFunction: () => {}
};

export const getLocaleForAppdomain = (appdomain) => {
    const config = getConfigForAppdomain(appdomain);

    return {
        ...translate,
        ...locales.compile(appdomain, config.locale[appdomain]),
    };
};
